export default {
  Profile: '/akun/profil',
  ProfileManagement: '/akun/profil-manajemen',
  Accounting: '/akun/akuntansi',
  Transactions: '/akun/transaksi',
  ArchiveReports: '/akun/arsip/laporan',
  AccountActivation: '/akun/pengaktifan',
  ArchiveNotifications: '/account/archive/notifications',
  Search: '/cari',
  CompanyDetail: '/perusahaan/:companyIdentifier/:slug',
  Investigation: '/investigasi',
  Cart: '/gerobak',
  PasswordReset: '/reset-kata-sandi',
  PasswordUpdate: '/pembaruan-kata-sandi',
  Register: '/daftar',
  Checkout: '/periksa',
  Billing: '/periksa/penagihan',
  Payment: '/periksa/pembayaran',
  Confirmation: '/periksa/konfirmasi',
  OrderProcessing: '/periksa/:orderId/pengolahan',
  UploadImport: '/import',
  Import: '/import/:importId',
  ImportHistory: '/account/archive/imports',
  ArchiveInvoices: '/account/archive/invoices'
}
